import { useBaseStore } from '@roc/feature-app-core';
import { DraftLoan } from '@roc/feature-types';
import { LoanSubType, isBackOfficeAppPath, isNil } from '@roc/feature-utils';
import { useOneToolRoutes } from '@roc/feature-one-tool';
import { useHistory } from 'react-router-dom';
import { routeByLoanSubType, useLoanSubmissionRoutes } from '../../loanSubmission';
import { useLoanStore } from './useLoanStore';

export const useOpenLoanSubmission = () => {
  const { loanStore } = useLoanStore();
  const { globalStore } = useBaseStore();
  const { loanSubmissionRoutesConfig } = useLoanSubmissionRoutes();
  const { oneToolRoutesConfig } = useOneToolRoutes();
  const { push, createHref } = useHistory();

  const openInNewTab = (pathname: string, params: Record<string, any> = {}) => {
    const query = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (!isNil(params[key])) {
        query.set(key, String(params[key]));
      }
    });
    const search = query.toString();
    window.open(createHref({ pathname, search: search ? `?${search}` : '' }), '_blank', 'noopener');
  };

  return (loanRequest: DraftLoan) => {
    if (isNil(loanRequest?.loanQuoteId) || loanRequest?.loanSubType == LoanSubType.FIX_AND_FLIP_PRO) {
      const url =
        loanSubmissionRoutesConfig.submitloan.children[
          routeByLoanSubType[loanRequest?.loanSubType]
        ].url;
      if (isBackOfficeAppPath()) {
        if (!loanStore.canContinueApplication(loanRequest?.loanType, loanRequest?.loanSubType)) {
          globalStore.notificationStore.showWarningNotification({
            message: 'Opening this loan type from here is not supported yet.',
          });
          return;
        }
        openInNewTab(url, {
          loanApplicationId: loanRequest?.loanApplicationId,
          loanType: loanRequest?.loanType,
          loanSubType: loanRequest?.loanSubType,
          companyId: loanRequest?.lenderCompanyId,
        });
        return;
      }
      loanStore.continueDraftLoan(loanRequest);
      push(url);
    } else {
      const route = oneToolRoutesConfig[routeByLoanSubType[loanRequest?.loanSubType]];
      const url = route(loanRequest?.loanQuoteId).url;
      if (isBackOfficeAppPath()) {
        openInNewTab(url, { companyId: loanRequest?.lenderCompanyId });
        return;
      }
      push(url);
    }
  };
};
